import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const securityAndAccess: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('admin-tabs.security-access-control') as string;
			},
		},
		path: 'security-and-access',
		name: Routes.GROUP_ADMIN_SECURITY_AND_ACCESS_CONTROL,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
			};
		},
		component: () => import(
			/* webpackChunkName: "group-admin-access-settings" */
			'@front-app/views/home/group/admin/SecuritySettings.vue'
		),
	},
];
